
import Vue from 'vue'
import { PropOptions } from 'vue/types/options'
import Information from '~/components/atoms/Information.vue'
import ArrowLink from '~/components/atoms/ArrowLink.vue'
import { Gender } from '~/types/api/result'

export default Vue.extend({
  components: {
    Information,
    ArrowLink,
  },
  props: {
    gender: {
      type: Object,
      required: true,
    } as PropOptions<Gender>,
  },
  methods: {
    openMagazine() {
      window.open(this.gender.magazineUrl)
    },
  },
})
